<template>
  <div class="container" style="padding-top: 90px; padding-bottom: 120px;">
    <LifeHeader :header="course.header"></LifeHeader>
    <div class="content">
      <SubHeader :backgroundUrl="course.headerUrl"></SubHeader>
      <div class="detail">
        <p v-for="(item, index) in course.detail" :key="index" v-html="item"></p>
      </div>
    </div>
  </div>
</template>

<script>
import LifeHeader from './Life_Header.vue'
import SubHeader from './Life_SubHeader.vue'

export default {
  components: {
    LifeHeader,
    SubHeader
  },
  props: ['course']
}
</script>



// WEBPACK FOOTER //
// src/components/STUDENTS/Life_Course.vue